import { TESTIMONIAL_GET_LIST,TESTIMONIAL_GET_LIST_SUCCESS,TESTIMONIAL_GET_LIST_ERROR } from "../../../redux/contants";

const INIT_STATE = {
    getTestimonialList: [],
    loading: false,
    error: '',
    messages: ''
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case TESTIMONIAL_GET_LIST:
            // alert(action.type)
            // alert(action.data)
            return { ...state, loading: true, error: '' };
        case TESTIMONIAL_GET_LIST_SUCCESS:
            console.log('TESTIMONIAL_GET_LIST_SUCCESS===',action);
            return {
                ...state,
                loading: false,
                getTestimonialList: action.data,
                error: '',
                messages: ''
            };
        case TESTIMONIAL_GET_LIST_ERROR:
            return {
                ...state,
                loading: false,
                getTestimonialList: [],
                error: action.error,
                messages: ''
            };
        default:
            return { ...state };
    }
};
